import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import messages from '../../messages';

const name = <FormattedMessage {...messages.parentSKUColumnHeader} />;

export default {
  name,
  getMessageDescriptor: () => messages.parentSKUColumnHeader,
  render: (data) => get(data, 'parentSKU', 0),
};
